import request from './requestWrapper';

// Types
import {SessionType} from "../types/sessionTypes";


function login(data: SessionType) {
  return request({
    url: 'collaboratorAuth/login',
    method: 'POST',
    data,
  });
}

function register(data: SessionType) {
  return request({
    url: 'collaboratorAuth/register',
    method: 'POST',
    data,
  });
}

function confirmEmail(code: string) {
  return request({
    url: 'collaboratorAuth/confirmEmail',
    method: 'POST',
    params: { code },
  });
}

function forgotPassword(data: SessionType) {
  return request({
    url: 'collaboratorAuth/forgotPassword',
    method: 'POST',
    data,
  });
}

function resetPassword(data: SessionType) {
  return request({
    url: 'collaboratorAuth/resetPassword',
    method: 'POST',
    data,
  });
}


function decryptTempToken(code: string) {
  return request({
    url: 'auth/decryptTempToken',
    method: 'POST',
    data: { c: code },
  });
}

export default {
  login,
  register,
  confirmEmail,
  forgotPassword,
  resetPassword,
  decryptTempToken
}